export default __webpack_public_path__ + "static/media/emptyWorkflow.6eeeac40.svg";